import mountVueOnPage from '../mount_vue'

// CSRF token for axios is configured once in application.js.
mountVueOnPage('account', 'avatar', {
    data() {
        return {
            purchases: [],
            search: '',
            filter: 'recent_purchases',
            equipped_filter: 'not_equipped',
            category: '',
            avatar_url: '',
            loading: true,
        }
    },
    async created() {
        await this.update();
    },
    methods: {
        async update() {
            await this.run_fetch('/account/avatar.json')
        },
        async equip(id) {
            await this.run_fetch(`/account/equip/${id}.json`, false)
        },
        async unequip(id) {
            await this.run_fetch(`/account/unequip/${id}.json`, false)
        },
        async run_fetch(url, get = true) {
            this.loading = true;
            const posts = await axios({
                url: url,
                method: get ? 'get' : 'post',
                params: {
                    search: this.search,
                    filter: this.filter,
                    category: this.category,
                    equipped_filter: this.equipped_filter,
                },
            })
            this.loading = false;
            if (posts.data) {
                if (posts.data.error) {
                    console.log(posts.data.error);
                    return;
                }
                this.purchases = posts.data.purchases;
                this.avatar_url = posts.data.avatar_url;
            }
        }
    },
    watch: {
        async filter() {
            await this.update();
        },
        async category() {
            await this.update();
        },
        async equipped_filter() {
            await this.update();
        }
    }
})
